import * as yup from "yup";

export const RolesSetupValidationSchema = yup.object({
  roles: yup.string().required("Role is required"),
});
